export interface ITransactionIssuerAmount {
	amount: number | null
	currency: string | null
}

export interface ITransactionFeeLine {
	operation_id: number | null
	fee_code: string
	label?: string
	charged_by: "us" | "issuer"
	amount: number
	currency: string
	status: "charged" | "failed" | "pending" | "skipped"
}

export interface ITransactionDetails {
	operation_id: number
	trx: {
		operation_id: number
		reference_id: string | null
		type_id: number
		type: string
		operation_type: ICompanyTrxTransaction["operation_type"]
		status: "completed" | "pending" | "error"
		amount: number
		currency: string
		description: string
		created_at: string
		merchant: ITransactionMerchant
		merchant_source: "trx" | "issuer" | "webhook" | null
		meta: unknown
		legs: Array<{
			id: number
			operation_id: number
			account_id: number
			counterparty_account_id: number
			direction: "income" | "expense"
			type_id: number
			type: string
			amount: number
			balance: number
			currency: string
			status: string
			description?: string
			reference_id?: string | null
			meta: unknown
			created_at: string
			updated_at: string
			user_id: number
			project_id: number
			seq: number
			is_initial: number
			account: (ICompanyTransactionAccountResponse & { name?: string }) | null
		}>
	}
	issuer: null | {
		issuer: number | null
		issuer_label: string
		kind: "card_transaction" | "topup" | "topup_fee" | "withdrawal" | "event_fee"
		card_uid: string | null
		issuer_reference: string | null
		order_id: string | null
		local: Record<string, unknown>
		webhook: unknown
		source: string | null
		matched_by: "reference" | "heuristic" | null
		raw: unknown
		fetched_at: string | null
		/** Same shape for every issuer; empty parts are `{ amount: null, currency: null }`. */
		amounts?: null | Record<"original" | "authorized" | "settled" | "fee" | "cross_border_fee", ITransactionIssuerAmount> & { source: "issuer" | "webhook" | null }
	}
	/** Fees taken from this operation (cabinet gets only `charged_by: "us"`). */
	fees?: ITransactionFeeLine[]
	issuer_error: IError | null
	/** Present only for commissions; null otherwise. */
	fee?: null | {
		fee_code: string
		label?: string
		charged_by: "us" | "issuer"
		payer: "company" | "buyer" | "card" | null
		amount: number
		currency: string
		card_uid: string | null
		buyer_uid: string | null
		team_uid: string | null
		source_kind: string | null
		source_ref: string | null
	}
}

export const transactionDetailsErrorMessage = (error: IError) => {
	const title = error.code === 3020 ? "Operation not found"
		: error.code === 1 ? "Invalid operation number"
		: error.code === 200 ? "Transaction details are temporarily unavailable, please try again later"
		: "Could not load transaction details"
	return `${title}${error.details ? `: ${error.details}` : ""}`
}
